import React, { useState, useCallback, useRef, useEffect } from 'react';
import clsx from 'clsx';
import styles from './DropdownTabs.module.scss';
import IconArrowDown from '@static/images/icon_arrow_down.svg';
import { Image } from '@colonist/ui';
export const DropdownTabs = ({ className, activeTabId, tabs, onTabChange, size })=>{
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const activeTab = tabs.find((tab)=>tab.id == activeTabId);
    const handleTabChange = useCallback((tabId)=>{
        setIsOpen(false);
        onTabChange(tabId);
    }, [
        onTabChange
    ]);
    useEffect(()=>{
        if (!isOpen) return;
        const handleClickOutside = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: clsx(styles.dropdownContainer, styles[size], className)
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": activeTab === null || activeTab === void 0 ? void 0 : activeTab.testId,
        className: clsx(styles.dropdownButton, isOpen && styles.active),
        onClick: ()=>setIsOpen(!isOpen)
    }, /*#__PURE__*/ React.createElement("span", null, activeTab === null || activeTab === void 0 ? void 0 : activeTab.label), /*#__PURE__*/ React.createElement(Image, {
        className: styles.dropdownArrow,
        image: {
            src: IconArrowDown,
            alt: 'strings:imgAlts.DownArrow'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.dropdownContents, isOpen && styles.open)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.dropdownInner
    }, tabs.filter((tab)=>tab.id != activeTabId).map((tab)=>/*#__PURE__*/ React.createElement("div", {
            key: tab.id,
            "data-testid": tab.testId,
            className: styles.dropdownItem,
            onClick: ()=>handleTabChange(tab.id)
        }, tab.label)))));
};
